import React from 'react';
import {connect} from 'react-redux';
import Script from 'react-load-script'
import forEach from 'lodash/forEach';
import {messageTopolSaved} from "../../actions/messageActions";
import {Modal} from '@material-ui/core';
import {withTranslation} from 'react-i18next';
import {getLocale} from '../../util/i18n';
import {getLandingPagesMergeTags} from "../../util/topol/landingPages";

class Topol extends React.Component {
    state = {
        duplicating: false
    };

    async scriptLoaded() {
        const {accountId, dispatch, t} = this.props;

        const landingPagesMergeTags = await getLandingPagesMergeTags(t);

        // noinspection HtmlUnknownTarget
        const TOPOL_OPTIONS = {
            id: '#topol-container',
            language: getLocale(),
            authorize: {
                apiKey: 'Med6kGtUDYWYq2SLbIVQrdL3SBOq77rikND1Ca4Z4BWaYf6TU6rko6zfeUda',
                userId: accountId,
            },
            removeTopBar: true,
            light: true,
            callbacks: {
                onSaveAndClose: function (json, html) {
                    dispatch(messageTopolSaved({json: JSON.stringify(json), html}));
                },
                onSave: function (json, html) {
                    dispatch(messageTopolSaved({json: JSON.stringify(json), html}));
                },
            },
            contentBlocks: {
                product: {
                    disabled: true,
                    disabledText: 'Disabled',
                    hidden: true,
                }
            },
            fonts: [
                {
                    'label': 'Arial',
                    'style': 'Arial, sans-serif'
                },
                {
                    'label': 'Georgia',
                    'style': 'Georgia, serif'
                },
                {
                    'label': 'Helvetica',
                    'style': 'Helvetica, sans-serif'
                },
                {
                    'label': 'Verdana',
                    'style': 'Verdana, sans-serif'
                },
            ],
            customFonts: {
                override: false,
                fonts: [
                    {
                        label: 'Anton',
                        style: "'Anton', sans-serif",
                        url: 'https://fonts.googleapis.com/css2?family=Anton&display=swap',
                    },
                    {
                        label: 'Baloo Tamma 2',
                        style: "'Baloo Tamma 2', sans-serif",
                        url: 'https://fonts.googleapis.com/css2?family=Baloo+Tamma+2:wght@400..800&display=swap',
                    },
                    {
                        label: 'Bebas Neue',
                        style: "'Bebas Neue', sans-serif",
                        url: 'https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap',
                    },
                    {
                        label: 'Dancing Script',
                        style: "'Dancing Script', cursive",
                        url: 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&display=swap',
                    },
                    {
                        label: 'Inconsolata',
                        style: "'Inconsolata', monospace",
                        url: 'https://fonts.googleapis.com/css2?family=Inconsolata:wght@200..900&display=swap',
                    },
                    {
                        label: 'Indie Flower',
                        style: "'Indie Flower', cursive",
                        url: 'https://fonts.googleapis.com/css2?family=Indie+Flower&display=swap',
                    },
                    {
                        label: 'Libre Baskerville',
                        style: "'Libre Baskerville', serif",
                        url: 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&display=swap',
                    },
                    {
                        label: 'Lobster',
                        style: "'Lobster', cursive",
                        url: 'https://fonts.googleapis.com/css2?family=Lobster&display=swap',
                    },
                    {
                        label: 'Manrope',
                        style: "'Manrope', sans-serif",
                        url: 'https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap',
                    },
                    {
                        label: 'Noto Sans Display',
                        style: "'Noto Sans Display', sans-serif",
                        url: 'https://fonts.googleapis.com/css2?family=Noto+Sans+Display:ital,wght@0,100..900;1,100..900&display=swap',
                    },
                    {
                        label: 'Noto Serif',
                        style: "'Noto Serif', serif",
                        url: 'https://fonts.googleapis.com/css2?family=Noto+Serif:ital,wght@0,100..900;1,100..900&display=swap',
                    },
                    {
                        label: 'Noto Serif Display',
                        style: "'Noto Serif Display', serif",
                        url: 'https://fonts.googleapis.com/css2?family=Noto+Serif+Display:ital,wght@0,100..900;1,100..900&display=swap',
                    },
                    {
                        label: 'Nunito',
                        style: "'Nunito', sans-serif",
                        url: 'https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap',
                    },
                    {
                        label: 'Pangolin',
                        style: "'Pangolin', cursive",
                        url: 'https://fonts.googleapis.com/css2?family=Pangolin&display=swap',
                    },
                    {
                        label: 'Shadows Into Light',
                        style: "'Shadows Into Light', cursive",
                        url: 'https://fonts.googleapis.com/css2?family=Shadows+Into+Light&display=swap',
                    },
                    {
                        label: 'Sriracha',
                        style: "'Sriracha', Tahoma, cursive",
                        url: 'https://fonts.googleapis.com/css2?family=Sriracha&display=swap',
                    },
                ],
            },
            mergeTags: [
                {
                    name: t('Merge tags'),
                    items: [
                        {
                            value: "*|email|*",
                            text: "Email",
                            label: t('Contact attribute: %{field}', {field: 'Email'}),
                        }
                    ]
                },
                {
                    name: t('Special links'),
                    items: [
                        {
                            value: '<a href="*|unsubscribe|*">Unsubscribe</a>',
                            text: t('Unsubscribe link'),
                            label: t('Unsubscribe link'),
                        },
                        {
                            value: '<a href="*|show-in-browser|*">Web version</a>',
                            text: t('Web version'),
                            label: t('Web version'),
                        },
                    ]
                },
                landingPagesMergeTags
            ],
            sendTestEmail: false,
        };

        forEach(this.props.attributes, (value) => {
            TOPOL_OPTIONS.mergeTags[0].items.push({
                value: '*|' + value.name + '|*',
                text: value.name,
                label: t('Contact attribute: %{field}', {field: value.name}),
            });
        });

        window.TopolPlugin.init(TOPOL_OPTIONS);

        // duplicating
        if (this.props.json !== '' && this.props.html === '') {
            this.setState({duplicating: true});

            setTimeout(() => {
                window.TopolPlugin.load(this.props.json);
                this.setState({duplicating: false});
            }, 5000);
        } else if (this.props.json !== '') {
            window.TopolPlugin.load(this.props.json);
        }

        if (!window.autoSaveTimer) {
            window.autoSaveTimer = setInterval(() => window.TopolPlugin.save(), 60 * 1000);
        }
    }

    componentWillUnmount() {
        if (window.TopolPlugin) {
            window.TopolPlugin.destroy();
        }
    }

    render() {
        const {accountId, messageId} = this.props;
        const {duplicating} = this.state;

        if (!accountId || !messageId) {
            return <span/>;
        }

        return (
            <div>
                {duplicating &&
                <Modal open={true}>
                    <span/>
                </Modal>
                }

                <Script url={'https://d5aoblv5p04cg.cloudfront.net/editor-3/loader/build.js'}
                        onLoad={() => this.scriptLoaded()}/>
                <div id={'topol-container'} style={{height: '65vh'}}/>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    dispatch,
});

export default connect(null, mapDispatchToProps)(withTranslation()(Topol));
